import React from 'react';

// Rendu de l'énoncé d'une question avec un markdown minimal :
// **gras** pour les termes clés et `backticks` pour le code inline.
// Les énoncés sans marqueurs (anciennes questions, fallbacks) s'affichent tels quels.

const renderInlineCode = (text: string, keyPrefix: string): React.ReactNode[] =>
    text.split(/(`[^`]+`)/g).filter(Boolean).map((part, i) =>
        part.startsWith('`') && part.endsWith('`') && part.length > 2 ? (
            <code
                key={`${keyPrefix}-c${i}`}
                className="px-1.5 py-0.5 rounded bg-gray-100 dark:bg-gray-700/60 font-mono text-[0.9em] text-blue-700 dark:text-blue-300"
            >
                {part.slice(1, -1)}
            </code>
        ) : (
            <React.Fragment key={`${keyPrefix}-t${i}`}>{part}</React.Fragment>
        )
    );

const renderSegments = (text: string): React.ReactNode[] =>
    text.split(/(\*\*[^*]+\*\*)/g).filter(Boolean).map((part, i) =>
        part.startsWith('**') && part.endsWith('**') && part.length > 4 ? (
            <strong key={`b${i}`} className="font-semibold text-gray-900 dark:text-white">
                {renderInlineCode(part.slice(2, -2), `b${i}`)}
            </strong>
        ) : (
            <React.Fragment key={`s${i}`}>{renderInlineCode(part, `s${i}`)}</React.Fragment>
        )
    );

interface QuestionPromptProps {
    text: string;
    className?: string;
}

export const QuestionPrompt: React.FC<QuestionPromptProps> = ({ text, className = '' }) => {
    const paragraphs = text.split(/\n+/).map(p => p.trim()).filter(Boolean);

    return (
        <div className={`space-y-2.5 ${className}`}>
            {paragraphs.map((p, i) => (
                <p key={i} className="text-gray-900 dark:text-gray-100 leading-relaxed">
                    {renderSegments(p)}
                </p>
            ))}
        </div>
    );
};

export default QuestionPrompt;
